import React from 'react';
import { prefix } from '../../config';
import hocWrapper from './hocWrapper';

const Img = props => {
    const { id, type, attr = {} } = props.item;

    return (
        <img
            className={`${prefix}-${type}-${id}`}
            src={attr.src || '/assets/images/image-placeholder.jpg'}
            alt=""
        />
    );
};
export default hocWrapper(Img);
